import { Streamers } from 'components/template/streamers';
import { ssrApi } from 'api/ssr';
import {
  IStreamerCollection,
  IStreamerReview,
  IStreamer,
} from 'constants/types';

export default function StreamersPage({
  streamerCollections,
  reviews,
  reviewsCount,
  streamers,
  streamersCount,
  languages,
}: {
  streamerCollections: IStreamerCollection[];
  streamers: IStreamer[];
  streamersCount: number;
  reviews: IStreamerReview[];
  reviewsCount: number;
  languages: string[];
}) {
  return (
    <Streamers
      collections={streamerCollections}
      reviews={reviews}
      languages={languages}
      reviewsCount={reviewsCount}
      streamers={streamers}
      streamersCount={streamersCount}
    />
  );
}

const INITIAL_STREAMERS_LIMIT = 6;

export async function getServerSideProps() {
  const streamersResponse = await ssrApi.streamers.list({
    limit: INITIAL_STREAMERS_LIMIT,
    sortBy: 'popular',
  });

  return {
    props: {
      streamerCollections: [],
      reviews: [],
      languages: [],
      reviewsCount: 0,
      streamers: streamersResponse.streamers ?? [],
      streamersCount: streamersResponse.count ?? 0,
    },
  };
}
